export enum ContentModelId {
  ANNOUNCEMENT_BAR = 'annoncementBar',
  BANNER = 'banner',
  CARD = 'card',
  CARDS_GRID = 'cardsGrid',
  CAROUSEL_CONTENT = 'carrouselContent',
  COLUMN_CONTENT = 'columnContent',
  COMMON_ITEM = 'commonItem',
  CONNECTED_HOME = 'homeCooperative',
  CONTENT_BLOCK = 'advertorial',
  CONTENT_COLUMN = 'richBoxColumn',
  CONTENT_MEDIA = 'richBoxMedia',
  CONTENT_PAGE = 'richBox',
  CONTENTS_CAROUSEL = 'articleThumbnails',
  FAQ_BLOCK = 'faqBlock',
  FAQ_LIST = 'faqList',
  HOME_CONTENT_CARD = 'homeArticleCard',
  HUB = 'hub',
  IMAGE_GRID = 'imageGrid',
  INFORMATION_BLOCK = 'articleInformationBlock',
  LEGALS = 'legals',
  LIST_ITEMS = 'listItems',
  MAIN_BANNER = 'mainHeader',
  MAIN_BANNER_CARD = 'mainHeaderCard',
  MEGA_MENU = 'megaMenu',
  MIGRATION = 'migration',
  NATIONAL_HOME = 'home',
  NEWSLETTER = 'newsletter',
  ONE_PRODUCT_HIGHLIGHTING = 'pushProduct',
  PARTNER_MAIN_BANNER = 'partnerMainBanner',
  PRIVACY = 'privacy',
  PRODUCTS_CAROUSEL = 'articleCarouselProduct',
  PRODUCTS_CATEGORY_DESCRIPTION = 'categoryDescription',
  RICH_LINK = 'richLink',
  SPONSORING_PRODUCTS = 'supplierHighlight',
  STEPPER = 'stepper',
  STICKER = 'category',
  STICKERS_BLOCK = 'categories',
  THEME_INSERT = 'advertorialInsert',
  UNIVERSE_BLOCK_CONTENT = 'universeArticles',
  UNIVERSE_CONTENT = 'universeArticle',
  UNIVERSE_GENERAL_INFORMATION = 'universeGeneralInformation',
  UNIVERSE_HIGHLIGHTED_PRODUCTS = 'universeHighlightedProducts',
  UNIVERSE_PAGE = 'universePage',
  UNIVERSE_PRODUCTS_ILLUSTRATION = 'universeProductsIllustration',
  UNIVERSE_STICKER = 'universeCategory',
  UNIVERSE_STICKERS_BLOCKS = 'universeCategories',
  UNIVERSE_TEXT_AREA = 'universeTextArea',
}
